var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLikeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 40,
    viewBox: "0 0 46 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5065 1.125C6.91446 1.125 1.57031 6.42476 1.57031 12.962C1.57031 24.799 15.6767 35.56 23.2724 38.0629C30.8682 35.56 44.9745 24.799 44.9745 12.962C44.9745 6.42476 39.6304 1.125 33.0384 1.125C29.0018 1.125 25.4318 3.11255 23.2724 6.15466C22.1718 4.59992 20.7096 3.33109 19.0096 2.45558C17.3097 1.58006 15.422 1.12366 13.5065 1.125Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLikeWhite);
export default __webpack_public_path__ + "static/media/IconLikeWhite.5d1a82923eea8f7d554dc954df014e8a.svg";
export { ForwardRef as ReactComponent };